import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { DATE_FORMAT } from "@constants";
import iconBills from "@static/img/bills/icon-bills.png";
import { useDownloadBill } from "./hook/useDownloadBill";
import { format } from "date-fns";
import { Loader } from "@common/handleErrorAndLoading/Loader";

interface IParams {
    amount: number;
    billDate: string;
    billNumber: number;
}

export const Bills = (props: IParams) => {
    const { amount, billDate, billNumber } = props;

    const { downloadBill, downloadBillState } = useDownloadBill(billNumber);
    const { t } = useTranslation(["bills", "common"]);

    const billDateFormatted = format(new Date(billDate), DATE_FORMAT);
    const billAmount = t("common:price", { price: amount });

    return (
        <Grid alignItems="center" className="bills-history__bill" container spacing={2}>
            <Grid item sm={8} xs={6}>
                <Grid className="bills-history-infos" container>
                    <Grid className="bills-history__item" item sm={6} xs={12}>
                        <Typography align="center" color="secondary" variant="h5">
                            <strong>{t("bills:billIssued")}</strong>
                        </Typography>
                        <Typography align="center" variant="body1">
                            {`${t("bills:on")} ${billDateFormatted}`}
                        </Typography>
                    </Grid>
                    <Grid className="bills-history__item bills-history__separator" item sm={6} xs={12}>
                        <Typography align="center" color="secondary" variant="h2">
                            {billAmount}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid className="bills-history__item bills-history__view" item sm={4} xs={6}>
                {!downloadBillState.isLoading && (
                    <Fragment>
                        <IconButton aria-labelledby="viewBillsLabel" onClick={downloadBill}>
                            <img alt="Icon bill" src={iconBills} />
                        </IconButton>
                        <Typography align="center" id="viewBillsLabel" variant="body1">
                            {t("bills:viewBill")}
                        </Typography>
                    </Fragment>
                )}
                {downloadBillState.isLoading && <Loader size={40} />}
                {downloadBillState.error && (
                    <Typography align="center" color="error">
                        {t("common:genericError")}
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
};
